import { Check } from "@phosphor-icons/react";

const STAGES = [
  { id: "submitted", label: "Submitted" },
  { id: "preproduction", label: "Preproduction" },
  { id: "design", label: "Design" },
  { id: "review", label: "Review" },
  { id: "final", label: "Final" },
  { id: "delivered", label: "Delivered" },
];

export function StatusPipeline({ status }) {
  const currentIdx = STAGES.findIndex((s) => s.id === status);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2" data-testid="status-pipeline">
      {STAGES.map((stage, i) => {
        const isDone = i < currentIdx;
        const isActive = i === currentIdx;
        return (
          <div
            key={stage.id}
            className={`p-3 border ${
              isActive
                ? "border-[#FF2D2D] bg-[#FF2D2D]/5"
                : isDone
                ? "border-[#262626] bg-[#0f0f0f]"
                : "border-[#262626] bg-[#0a0a0a] opacity-50"
            }`}
            data-testid={`stage-${stage.id}`}
          >
            <div className="flex items-center justify-between mb-1">
              <span className="text-[10px] uppercase tracking-[0.2em] text-[#a3a3a3]">
                {String(i + 1).padStart(2, "0")}
              </span>
              {isDone && <Check size={12} weight="bold" className="text-[#FF2D2D]" />}
              {isActive && <span className="w-2 h-2 bg-[#FF2D2D] rounded-full animate-pulse" />}
            </div>
            <div className={`text-sm font-semibold ${isActive ? "text-white" : "text-[#a3a3a3]"}`}>
              {stage.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
